module.exports = __webpack_public_path__ + "static/media/eop-360x240.a021aaf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/adverts/eop-360x240.jpg
// module id = 41
// module chunks = 0